import { IApplicationState } from '../../types/redux';

export const selectResults = (state: IApplicationState) => state.results;
